import { render, staticRenderFns } from "./SettingsGlobal.vue?vue&type=template&id=5e0a0c2c&"
import script from "./SettingsGlobal.vue?vue&type=script&lang=ts&"
export * from "./SettingsGlobal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports